// src/authConfig.js
export const authConfig = {
  Auth: {
    Cognito: {
      userPoolId: "us-east-2_6zlODqhgh",
      userPoolClientId: "1i8ooke08s1e8ki0e69r8qr1eq",
      loginWith: {
        oauth: {
          domain: "auth.circlecitydata.com",
          scopes: ["openid", "email", "profile"],
          redirectSignIn: [
            "http://localhost:3000",
            "https://charts.circlecitydata.com/",
          ],
          redirectSignOut: [
            "http://localhost:3000",
            "https://charts.circlecitydata.com/",
          ],
          responseType: "code",
        },
      },
    },
  },
};

